// Komponen UI dikongsi: ikon, toast, modal, kad listing, status, carta, kalendar.

import { html, raw, esc, safeUrl, $, mount } from './html.js';
import { rm, BOOKING_TONE, STATUS_TONE, monthLabel, monthFull, weekdays, stateName } from './format.js';
import { t, th } from './i18n.js';

const P = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
export const ICONS = {
  search: P('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'),
  calendar: P('<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>'),
  heart: P('<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>'),
  chat: P('<path d="M4 5h16v11H8l-4 4z"/>'),
  user: P('<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>'),
  compass: P('<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5-5 2 2-5z"/>'),
  star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/></svg>',
  wifi: P('<path d="M2 9a15 15 0 0 1 20 0M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0"/><circle cx="12" cy="19.5" r="1"/>'),
  snow: P('<path d="M12 2v20M4 6l16 12M20 6 4 18"/>'),
  car: P('<path d="M5 16V11l2-5h10l2 5v5M3 16h18v3H3zM7 19v2M17 19v2"/>'),
  pool: P('<path d="M2 18c2 0 2-1.5 4-1.5s2 1.5 4 1.5 2-1.5 4-1.5 2 1.5 4 1.5 2-1 4-1M8 15V5a2 2 0 0 1 4 0M16 15V5a2 2 0 0 0-4 0M8 9h8"/>'),
  kitchen: P('<path d="M4 3v8a3 3 0 0 0 6 0V3M7 3v18M17 3c-2 2-3 5-3 8h3v10"/>'),
  mosque: P('<path d="M12 3c3 2 5 4 5 7H7c0-3 2-5 5-7zM5 21V12h14v9M10 21v-4a2 2 0 0 1 4 0v4M3 21h18"/>'),
  family: P('<circle cx="8" cy="7" r="3"/><circle cx="17" cy="9" r="2"/><path d="M3 21v-3a5 5 0 0 1 10 0v3M14 21v-2a3 3 0 0 1 6 0v2"/>'),
  paw: P('<circle cx="7" cy="9" r="2"/><circle cx="17" cy="9" r="2"/><circle cx="10" cy="5" r="2"/><circle cx="14" cy="5" r="2"/><path d="M12 12c-3 0-5 3-5 5.5S9 20 12 20s5-.5 5-2.5S15 12 12 12z"/>'),
  check: P('<path d="m5 12 5 5 9-10"/>'),
  home: P('<path d="M3 11 12 4l9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/>'),
  bed: P('<path d="M3 19v-9M3 14h18v5M21 14v-2a3 3 0 0 0-3-3h-7v5"/><circle cx="7" cy="11" r="2"/>'),
  bath: P('<path d="M4 12h16v3a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM6 12V5a2 2 0 0 1 4 0"/>'),
  guests: P('<circle cx="9" cy="8" r="3"/><path d="M3 20c.8-3.5 3.2-5 6-5s5.2 1.5 6 5M16 5a3 3 0 0 1 0 6M18 15c1.8.6 3 2.2 3.5 5"/>'),
  bell: P('<path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 21h4"/>'),
  shield: P('<path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z"/>'),
  key: P('<circle cx="8" cy="15" r="4"/><path d="m11 12 9-9M17 6l3 3"/>'),
  generic: P('<circle cx="12" cy="12" r="3"/>'),
  villa: P('<path d="M2 12 12 4l10 8M5 10v10h14V10M10 20v-5h4v5M15 7V4h3v5.5"/>'),
  cabin: P('<path d="M3 20 12 4l9 16M7.5 12h9M10 20v-4h4v4M2 20h20"/>'),
  building: P('<path d="M5 21V4h10v17M15 9h4v12M3 21h18M8 8h4M8 12h4M8 16h4"/>'),
  apartment: P('<rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-3h4v3"/>'),
  leaf: P('<path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15a1 1 0 0 1-1-1zM5 19l7-7"/>'),
  wave: P('<path d="M2 15c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2M2 19c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2M7 9l3-5 3 5 2-3 3 4"/>'),
  pin: P('<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'),
  receipt: P('<path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3"/>'),
  printer: P('<path d="M7 8V3h10v5M7 17H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M7 14h10v7H7z"/>'),
};
export const icon = (name) => raw(ICONS[name] || ICONS.generic);
const AMENITY_ICON = { wifi: 'wifi', aircond: 'snow', parking: 'car', pool: 'pool', kitchen: 'kitchen', prayer_room: 'mosque', qibla: 'compass', family_friendly: 'family', pet_friendly: 'paw', cctv: 'shield', self_checkin: 'key' };
export const amenityIcon = (k) => icon(AMENITY_ICON[k] || 'check');

let toastTimer;
export function toast(msg, { error = false } = {}) {
  const el = $('#toast');
  el.textContent = msg;
  el.className = `toast show${error ? ' err' : ''}`;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { el.className = 'toast'; }, 3800);
}
// Kod ralat Firebase Auth yang diterjemah (selainnya mesej umum) supaya tiada teks Inggeris mentah.
export const FIREBASE_AUTH_ERRORS = ['email-already-in-use', 'invalid-credential', 'wrong-password', 'user-not-found', 'weak-password',
  'invalid-email', 'popup-closed-by-user', 'cancelled-popup-request', 'popup-blocked', 'too-many-requests', 'network-request-failed',
  'account-exists-with-different-credential', 'unauthorized-domain', 'user-disabled', 'internal-error', 'missing-password'];

export function errorMessage(e) {
  const code = typeof e?.code === 'string' && e.code.startsWith('auth/') ? e.code.slice(5) : null;
  if (code) return FIREBASE_AUTH_ERRORS.includes(code) ? t(`fberr.${code.replace(/-/g, '_')}`) : t('fberr.generic');
  return e?.message || t('err.generic');
}

export function showError(e) {
  if (e?.code === 'auth/popup-closed-by-user' || e?.code === 'auth/cancelled-popup-request') return;
  toast(errorMessage(e), { error: true });
}

export function modal(title, content, { onMount } = {}) {
  const root = $('#modal-root');
  const prevFocus = document.activeElement;
  mount(root, html`<div class="modal-back" data-close="1"><div class="modal" role="dialog" aria-modal="true" aria-labelledby="mtitle">
    <div class="modal-head"><h2 id="mtitle" style="margin:0">${title}</h2><button class="xbtn" data-close="1" aria-label="${t('common.close')}">×</button></div>
    <div class="modal-body">${content}</div></div></div>`);
  const close = () => { root.innerHTML = ''; document.removeEventListener('keydown', onKey); prevFocus?.focus?.(); };
  const onKey = (e) => { if (e.key === 'Escape') close(); };
  document.addEventListener('keydown', onKey);
  root.querySelector('.modal-back').addEventListener('click', (e) => { if (e.target.dataset.close) close(); });
  const body = root.querySelector('.modal-body');
  (root.querySelector('.modal input, .modal select, .modal textarea, .modal button:not(.xbtn)') || root.querySelector('.xbtn')).focus();
  onMount?.(body, close);
  return { close, body };
}

export function confirmDialog(title, message, { confirmText = t('common.continue'), danger = false, input = null } = {}) {
  return new Promise((resolve) => {
    const m = modal(title, html`<p>${message}</p>
      ${input ? html`<label class="field"><span>${input.label}</span>${input.textarea ? html`<textarea class="input" id="cd-in" placeholder="${input.placeholder || ''}"></textarea>` : html`<input class="input" id="cd-in" placeholder="${input.placeholder || ''}">`}</label>` : ''}
      <div class="row" style="justify-content:flex-end;margin-top:16px"><button class="btn btn-ghost" id="cd-no">${t('common.cancel')}</button><button class="btn ${danger ? 'btn-danger' : 'btn-primary'}" id="cd-yes">${confirmText}</button></div>`, {
      onMount(body, close) {
        body.querySelector('#cd-no').onclick = () => { close(); resolve(null); };
        body.querySelector('#cd-yes').onclick = () => {
          const v = input ? body.querySelector('#cd-in').value.trim() : true;
          if (input?.required && !v) { body.querySelector('#cd-in').focus(); return; }
          close();
          resolve(v);
        };
      },
    });
    return m;
  });
}

export function statusBadge(status, map = 'generic') {
  const booking = map === 'booking';
  const label = t(`${booking ? 'bstatus' : 'status'}.${status}`);
  const tone = (booking ? BOOKING_TONE : STATUS_TONE)[status] || '';
  return html`<span class="status ${tone}">${label}</span>`;
}

export function stars(v) {
  return html`<span class="rating" aria-label="${v ? t('rating.aria', { v: Number(v).toFixed(1) }) : t('rating.new')}">${icon('star')}${v ? Number(v).toFixed(2).replace(/0$/, '') : t('rating.new')}</span>`;
}

export function initials(name) {
  return String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

export function propertyCard(p, { saved = false, query = '' } = {}) {
  const img = p.photos?.[0]?.url;
  return html`<article class="pcard">
    <a href="#/property/${esc(p.id)}${query}" class="ph" style="display:block" aria-label="${p.name}">${img ? html`<img src="${safeUrl(img)}" alt="" loading="lazy">` : ''}
      ${p.featured ? html`<span class="tag">${t('card.featured')}</span>` : ''}</a>
    <button class="heart" data-wish="${p.id}" aria-pressed="${saved}" aria-label="${saved ? t('wishlist.remove') : t('wishlist.add')}">${icon('heart')}</button>
    <a href="#/property/${esc(p.id)}${query}" class="body" style="display:block;color:inherit;text-decoration:none">
      <div class="t"><span data-ugc>${p.name}</span>${stars(p.rating_avg)}</div>
      <div class="loc">${p.city}, ${stateName(p.state)}</div>
      <div class="loc">${t('card.capacity', { n: p.capacity, rooms: p.bedrooms })}</div>
      <div class="price">${th('card.per_night', { price: html`<b>${rm(p.base_price_minor)}</b>` })}</div>
    </a></article>`;
}

export function loading() {
  return html`<div class="spinner" role="status" aria-label="${t('common.loading')}"></div>`;
}

export function emptyState(title, text, action) {
  return html`<div class="empty"><h3>${title}</h3><p>${text}</p>${action || ''}</div>`;
}

// ---------- Carta bar SVG (12 bulan) ----------
export function barChart(title, series, { money = false, suffix = '' } = {}) {
  const W = 360, H = 170, padL = 6, padB = 22, top = 16;
  const max = Math.max(1, ...series.map((s) => Math.abs(s.value)));
  const bw = (W - padL * 2) / series.length;
  const fmt = (v) => (money ? rm(v) : `${v}${suffix}`);
  const total = series.reduce((s, x) => s + x.value, 0);
  const bars = series.map((s, i) => {
    const h = Math.round((Math.abs(s.value) / max) * (H - padB - top));
    const x = padL + i * bw + bw * 0.18;
    const y = H - padB - h;
    return `<rect class="bar${s.value < 0 ? ' neg' : ''}" x="${x.toFixed(1)}" y="${y}" width="${(bw * 0.64).toFixed(1)}" height="${Math.max(h, s.value ? 2 : 0)}" rx="3"><title>${esc(monthLabel(s.month))}: ${esc(fmt(s.value))}</title></rect>
      ${i % 2 === series.length % 2 ? '' : `<text x="${(x + bw * 0.32).toFixed(1)}" y="${H - 6}" text-anchor="middle">${esc(monthLabel(s.month).split(' ')[0])}</text>`}`;
  }).join('');
  return html`<figure class="chart panel" style="margin:0"><figcaption class="spread"><b>${title}</b><span class="muted small">${suffix === '%' ? t('chart.average', { v: `${(total / series.length).toFixed(1)}%` }) : t('chart.total', { v: fmt(total) })}</span></figcaption>
    ${raw(`<svg viewBox="0 0 ${W} ${H}" role="img" aria-label="${esc(title)}"><line class="axis" x1="0" x2="${W}" y1="${H - padB}" y2="${H - padB}"/>${bars}</svg>`)}</figure>`;
}

// ---------- Kalendar julat tarikh ----------
// opts: { start, end, minDate, view, unavailable:Set, months:1|2, onChange, mode:'range'|'multi'|'single', marks: Map(date->class) }
export function calendar(container, opts) {
  const st = { view: (opts.view || opts.start || opts.minDate).slice(0, 7), start: opts.start || null, end: opts.end || null, picked: new Set(opts.picked || []) };
  const months = opts.months || (window.innerWidth >= 720 ? 2 : 1);
  function monthGrid(ym) {
    const [y, m] = ym.split('-').map(Number);
    const first = new Date(Date.UTC(y, m - 1, 1)).getUTCDay();
    const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
    const cells = [];
    for (let i = 0; i < first; i++) cells.push('<td></td>');
    for (let d = 1; d <= days; d++) {
      const iso = `${ym}-${String(d).padStart(2, '0')}`;
      const past = iso < opts.minDate;
      const unav = opts.unavailable?.has(iso);
      let cls = 'd';
      const mark = opts.marks?.get(iso);
      if (mark) cls += ' ' + mark;
      if (opts.mode === 'multi' && st.picked.has(iso)) cls += ' picked';
      if (st.start && iso === st.start) cls += ' sel';
      if (st.end && iso === st.end) cls += ' sel';
      if (st.start && st.end && iso > st.start && iso < st.end) cls += ' inr';
      const disabled = past || (opts.mode !== 'multi' && unav && !(st.start && !st.end && iso > st.start && canCheckout(iso)));
      cells.push(`<td><button type="button" class="${cls}" data-d="${iso}" ${disabled ? 'disabled' : ''} aria-label="${esc(t(unav ? 'cal.day_unavailable' : 'cal.day', { d, month: monthFull(m) }))}">${d}</button></td>`);
    }
    const rows = [];
    for (let i = 0; i < cells.length; i += 7) rows.push(`<tr>${cells.slice(i, i + 7).join('')}</tr>`);
    return `<div><div class="cal-head"><b>${esc(monthFull(m))} ${y}</b></div><table><thead><tr>${weekdays().map((h) => `<th>${esc(h)}</th>`).join('')}</tr></thead><tbody>${rows.join('')}</tbody></table></div>`;
  }
  // Tarikh keluar boleh jatuh pada malam yang ditempah orang lain (malam itu tidak diduduki).
  function canCheckout(iso) {
    let d = st.start;
    while (d < iso) {
      if (opts.unavailable?.has(d)) return false;
      const n = new Date(d + 'T00:00:00Z');
      n.setUTCDate(n.getUTCDate() + 1);
      d = n.toISOString().slice(0, 10);
    }
    return true;
  }
  function shift(ym, n) {
    const [y, m] = ym.split('-').map(Number);
    const d = new Date(Date.UTC(y, m - 1 + n, 1));
    return d.toISOString().slice(0, 7);
  }
  function draw() {
    const views = [st.view];
    if (months === 2) views.push(shift(st.view, 1));
    container.innerHTML = `<div class="cal"><div class="spread" style="margin-bottom:6px"><button type="button" class="cal-nav" data-nav="-1" aria-label="${esc(t('cal.prev'))}">‹</button><span class="small muted">${opts.hint ? esc(opts.hint) : ''}</span><button type="button" class="cal-nav" data-nav="1" aria-label="${esc(t('cal.next'))}">›</button></div><div class="cal-months ${months === 2 ? 'two' : ''}">${views.map(monthGrid).join('')}</div></div>`;
  }
  container.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-nav]');
    if (nav) { st.view = shift(st.view, Number(nav.dataset.nav)); draw(); return; }
    const b = e.target.closest('button.d');
    if (!b || b.disabled) return;
    const d = b.dataset.d;
    if (opts.mode === 'single') {
      st.start = d;
      draw();
      opts.onChange?.(d);
      return;
    }
    if (opts.mode === 'multi') {
      st.picked.has(d) ? st.picked.delete(d) : st.picked.add(d);
      opts.onChange?.([...st.picked].sort());
    } else if (!st.start || st.end || d <= st.start) {
      if (opts.unavailable?.has(d)) return;
      st.start = d; st.end = null;
      opts.onChange?.(st.start, null);
    } else {
      if (!canCheckout(d)) { toast(t('cal.range_unavailable'), { error: true }); return; }
      st.end = d;
      opts.onChange?.(st.start, st.end);
    }
    draw();
  });
  draw();
  return { reset() { st.start = null; st.end = null; st.picked.clear(); draw(); }, redraw: draw, state: st };
}

export function formData(form) {
  const out = {};
  for (const [k, v] of new FormData(form).entries()) {
    if (typeof v === 'string') out[k] = v.trim();
  }
  return out;
}

export async function withBusy(btn, fn) {
  const label = btn.innerHTML;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  try {
    return await fn();
  } catch (e) {
    showError(e);
    return undefined;
  } finally {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.innerHTML = label;
  }
}

export function downloadBlob(filename, blob) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 500);
}
